module.exports = __webpack_public_path__ + "static/media/er.67f5cd29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/er.svg
// module id = 108
// module chunks = 0